(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/javascripts/deposit-limits-dialogs.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/javascripts/deposit-limits-dialogs.js');

'use strict';

const showLimitInformation = () => {
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Om insättningsgränser',
    icon: 'deposit-limits',
    branding: svs.ui.dialog.branding.TUR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Dina ins\xE4ttningsgr\xE4nser anger hur mycket pengar du kan s\xE4tta in varje dag, vecka och m\xE5nad.\n            Du f\xE5r b\xE4ttre koll p\xE5 ditt spelande och minskar risken att du spelar f\xF6r mer pengar \xE4n du t\xE4nkt fr\xE5n b\xF6rjan."
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Du kan \xE4ndra dina ins\xE4ttningsgr\xE4nser n\xE4r du vill.\n            Vid h\xF6jning av gr\xE4nsen per dag g\xE4ller det nya beloppet efter 72  timmar.\n            Vid h\xF6jning av gr\xE4nsen per vecka och m\xE5nad b\xF6rjar det nya  beloppet g\xE4lla 72 timmar efter att den innevarande perioden tagit slut.\n            N\xE4r du har n\xE5tt en ins\xE4ttningsgr\xE4ns kan du inte f\xF6ra \xF6ver mer  pengar till spelkontot f\xF6rr\xE4n n\xE4sta dag, respektive vecka och m\xE5nad."
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Den h\xF6gsta ins\xE4ttningsgr\xE4nsen du kan s\xE4tta \xE4r 1 000 kr om du \xE4r 18-19 \xE5r, 5 000 kr om du \xE4r 20-24 \xE5r och 10 000 kr om du \xE4r 25 \xE5r eller \xE4ldre."
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showLimitInformationFirstTime = () => {
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Varför behöver du sätta gränser?',
    icon: 'deposit-limits',
    branding: svs.ui.dialog.branding.TUR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Enligt spellagen beh\xF6ver du s\xE4tta ins\xE4ttningsgr\xE4nser per m\xE5nad, vecka och dag.\n           Det hj\xE4lper dig att h\xE5lla koll p\xE5 hur mycket du s\xE4tter in p\xE5 ditt spelkonto. N\xE4r du n\xE5r en ins\xE4ttningsgr\xE4ns kan du inte s\xE4tta in pengar f\xF6rr\xE4n dagen, veckan eller m\xE5naden \xE4r \xF6ver."
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showSlsError = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Tekniska problem',
    type: svs.ui.dialog.type.ERROR,
    branding: svs.ui.dialog.branding.TUR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Vi  jobbar för fullt med att lösa problemet. Prova igen senare.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
svs.accountservicesReact.gameLimitDepositsForm.dialogs = {
  showLimitInformation,
  showLimitInformationFirstTime,
  showSlsError
};

 })(window);